import * as React from "react";
import { ResponsiveBar } from "@nivo/bar";
import Typography from "@material-ui/core/Typography";
import Tooltip from "./BarChartTooltip";
import { consts } from "../../common/consts";
import { calcGridYValues } from "./helpers/dashboardHelpers";

const theme = {
    axis: {
        ticks: {
            text: {
                fill: "#fff",
                fontSize: "12px",
            },
        },
    },
    legends: {
        text: {
            fill: "#fff",
        },
    },
};

const CustomTick = (tick: any) => {
    return (
        <g transform={`translate(${tick.x - 5},${tick.y + 15})`}>
            <text
                textAnchor="middle"
                dominantBaseline="middle"
                style={{
                    fill: '#ffffff7f',
                    fontSize: 12,
                }}
            >
                {tick.value}
            </text>
        </g>
    )
}

const BarChart = (props: any) => {
    const maxVal = Math.max(...props.barChartData.map((item: any) => {
        return (item["6-8"] + item["8-10"] + item["10-12"] + item["12-14"] + item["14-16"] + item["Other"]);
    }));
    const formattedData = props.barChartData.map((item: any) => {
        return {
            "6AM - 8AM": item["6-8"],
            "8AM - 10AM": item["8-10"],
            "10AM - 12PM": item["10-12"],
            "12PM - 2PM": item["12-14"],
            "2PM - 4PM": item["14-16"],
            "Other": item["Other"],
            "Weekday": item["Weekday"]
        };
    })
    return (
        <>
            <div style={{ marginTop: "40px", marginLeft: "15%" }}>
                <Typography variant="h4">{props.title}</Typography>
                <Typography style={{ fontSize: 15, color: "#ffffff7f" }}>{props.subtitle}</Typography>
            </div>
            <div style={{ height: 250 }} id="tpt_time_day_week_cont">
                <ResponsiveBar
                    data={formattedData}
                    keys={consts.GRAPH_TIME}
                    enableLabel={false}
                    isInteractive={true}
                    indexBy="Weekday"
                    margin={{ top: 70, right: 50, bottom: 70, left: 60 }}
                    padding={0.85}
                    borderColor={{ theme: "background" }}
                    axisTop={null}
                    enableGridX={false}
                    enableGridY={true}
                    gridYValues={calcGridYValues(maxVal)}
                    axisRight={{
                        tickSize: 5,
                        tickValues: 3,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: "",
                        legendOffset: 0,
                    }}
                    axisBottom={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: "",
                        legendPosition: "end",
                        legendOffset: 6,
                    }}
                    axisLeft={null}
                    theme={theme}
                    colors={props.colors}
                    labelSkipWidth={12}
                    labelSkipHeight={12}
                    labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
                    legends={[
                        {
                            dataFrom: "keys",
                            anchor: "bottom",
                            direction: "row",
                            justify: false,
                            translateX: 0,
                            translateY: 70,
                            itemsSpacing: 25,
                            itemWidth: 65,
                            itemHeight: 10,
                            itemDirection: "left-to-right",
                            itemOpacity: 1,
                            symbolSize: 10,
                            symbolShape: "circle",
                            itemTextColor: "#fff",
                            effects: [
                                {
                                    on: "hover",
                                    style: {
                                        itemOpacity: 1,
                                    },
                                },
                            ],
                        },
                    ]}
                    animate={true}
                    motionStiffness={70}
                    motionDamping={15}
                    tooltip={Tooltip}
                />
            </div>
        </>
    )
};

export default BarChart;
